const { default: axiosIns } = require('@/libs/axios')

const AdFormatsService = {
  // GET - AdFormatsApiController
  async getAdFormats() {
    return axiosIns.get('admin/adFormats')
      .then(response => response.data)
  },
  async getAdFormat(adFormatId) {
    return axiosIns.get(`admin/adFormats/${adFormatId}`)
      .then(response => response.data)
  },
  // PUT - AdFormatsApiController
  async updateAdFormat(model) {
    return axiosIns.put(`admin/adFormats/${model.id}`, model)
      .then(response => response.data)
  },
}

export default AdFormatsService
